<!--

@@author        j0Shi
@@date          2019.06.18
@@desc          Standard template for select boxes
@@usedby        SelectDuration > ObjectVavancyForm > Object
                SelectPersons > ObjectVavancyForm > Object

-->
<template>
  <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
  <select
    :value="value"
    @change="$emit('input', $event.target.value)"
  >
    <template v-for="option in options">
      <!-- check whether value is another object and create optgroup -->
      <optgroup
        v-if="typeof option.value === 'object'"
        :key="option.label"
        :label="option.label"
      >
        <option
          v-for="item in option.value"
          :key="item.value"
          :selected="value == option.value ? 'selected': false"
          :value="item.value"
        >
          {{ item.label }}
        </option>
      </optgroup>
      <!-- no optgroup, just render option element -->
      <option
        v-else
        :key="option.value"
        :selected="value == option.value ? 'selected': false"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </template>
  </select>
</template>

<script>
export default {
  name: 'SelectStandard',
  props: {
    // Option-Array: [{ value, label }]
    // Options can have another Option-Array as values.
    // Component renders optgroup in that case
    options: {
      required: true,
      type: Array,
      default: () => [],
    },
    // predefined value of the select
    value: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    // return whether or not the select box has optgroups
    hasOptGroups() {
      let foundGroups = false;
      this.options.forEach((v) => {
        if (typeof v.value === 'object') foundGroups = true;
      });
      return foundGroups;
    },
    // returns the number of options in the select
    optionCount() {
      return this.options.map((v) => (typeof v.value === 'object' ? v.value.length : 1)).reduce((total, num) => total + parseInt(num, 10));
    },
  },
};
</script>
